(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["New-blog"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-blog-slider]').forEach(function (wrapper) {
    const track = wrapper.querySelector('[data-slider-track]');
    const slides = wrapper.querySelectorAll('.blog-slider__slide');

    if (!track || slides.length < 2) return;

    let current = 0;
    let timer;
    const DELAY = 5000;

    /* DOTS */
    const dotsWrap = document.createElement('div');
    dotsWrap.className = 'blog-slider__dots';

    const dots = Array.from(slides).map((_, i) => {
      const dot = document.createElement('button');
      dot.className = 'blog-slider__dot';

      dot.addEventListener('click', () => {
        goTo(i);
        start();
      });

      dotsWrap.appendChild(dot);
      return dot;
    });

    wrapper.appendChild(dotsWrap);

    function goTo(index) {
      index = (index + slides.length) % slides.length;

      track.style.transform = `translateX(-${index * 100}%)`;

      slides.forEach((s, i) => {
        s.classList.toggle('is-active', i === index);
      });

      dots.forEach((d, i) => {
        d.classList.toggle('is-active', i === index);
      });

      current = index;
    }

    function start() {
      clearInterval(timer);
      timer = setInterval(() => goTo(current + 1), DELAY);
    }

    goTo(0);
    start();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-filter-new"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {

  const tabs = document.querySelectorAll(".filter-tabs .tab");
  const cards = document.querySelectorAll(".blog-card");

  tabs.forEach(tab => {
    tab.addEventListener("click", function () {

      tabs.forEach(t => t.classList.remove("active"));
      this.classList.add("active");

      const tag = this.dataset.tag;

      cards.forEach(card => {
        const tags = card.dataset.tags;

        if (tag === "all" || tags.includes(tag)) {
          card.style.display = "block";
        } else {
          card.style.display = "none";
        }
      });

    });
  });

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-blog-slider]').forEach(function (wrapper) {
      const track   = wrapper.querySelector('[data-slider-track]');
      const slides  = wrapper.querySelectorAll('.blog-slider__slide');
      const dots    = wrapper.querySelectorAll('.blog-slider__dot');

      if (!track || slides.length < 2) return;

      let current = 0;
      let autoplayTimer = null;
      const DELAY = 5000;

      function goTo(index) {
        index = (index + slides.length) % slides.length;
        track.style.transform = 'translateX(-' + (index * 100) + '%)';
        slides.forEach(function (s, i) {
          s.classList.toggle('is-active', i === index);
          s.setAttribute('aria-hidden', i !== index ? 'true' : 'false');
        });
        dots.forEach(function (d, i) {
          d.classList.toggle('is-active', i === index);
          d.setAttribute('aria-selected', i === index ? 'true' : 'false');
        });
        current = index;
      }

      function startAutoplay() {
        clearInterval(autoplayTimer);
        autoplayTimer = setInterval(function () { goTo(current + 1); }, DELAY);
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          goTo(parseInt(dot.getAttribute('data-dot-index'), 10));
          startAutoplay();
        });
      });

      let touchStartX = 0;
      wrapper.addEventListener('touchstart', function (e) { touchStartX = e.changedTouches[0].clientX; }, { passive: true });
      wrapper.addEventListener('touchend', function (e) {
        const diff = touchStartX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 50) { goTo(diff > 0 ? current + 1 : current - 1); startAutoplay(); }
      }, { passive: true });

      wrapper.addEventListener('mouseenter', function () { clearInterval(autoplayTimer); });
      wrapper.addEventListener('mouseleave', startAutoplay);

      wrapper.setAttribute('tabindex', '0');
      wrapper.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft')  { goTo(current - 1); startAutoplay(); }
        if (e.key === 'ArrowRight') { goTo(current + 1); startAutoplay(); }
      });

      startAutoplay();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
